import { useRef, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testid }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch { toast.error("Upload failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-20 h-20 rounded-xl border border-white/10 bg-white/5 overflow-hidden flex items-center justify-center shrink-0">
        {value ? <img src={imageUrl(value)} alt="" className="w-full h-full object-cover" /> : <Upload className="text-white/30" size={20} />}
      </div>
      <div className="flex-1">
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Paste image URL or upload"
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm mb-2 focus:border-cyan outline-none" />
        <input ref={ref} type="file" accept="image/*" hidden onChange={handle} data-testid={testid} />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          className="mono-label text-cyan flex items-center gap-2">
          {busy ? <><Loader2 size={13} className="animate-spin" /> Uploading</> : <><Upload size={13} /> Upload file</>}
        </button>
      </div>
    </div>
  );
}
